import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { FC } from "react";
import __ from "src/utils/Translations";
import { blueGrey } from "@mui/material/colors";
import { Avatar, PresenceIndicator } from "@benefit-systems/hr-tools-ui";
import { PresenceInformation } from "src/Components/Avatar/presenceColor/models/employeePresence.models";

interface IEmployeeChip {
  employeeName: string | null;
  fk: string | null;
  position: string | null;
  area: string | null;
  initials: string;
  avatar: string | undefined;
  onRemove?: () => void;
  disableBorder?: boolean;
  presenceInformation?: PresenceInformation;
}

const EmployeeChip: FC<IEmployeeChip> = ({
  employeeName,
  fk,
  position,
  area,
  initials,
  avatar,
  onRemove,
  disableBorder,
  presenceInformation,
}) => {
  const muiAvatar = avatar === null ? undefined : avatar;

  const typographySx = {
    m: 0,
    fontSize: "12px",
    lineHeight: "14px",
  };
  return (
    <Box
      sx={{
        padding: "12px 16px",
        height: "78px",
        borderRadius: "12px",
        border: disableBorder ? "" : "1px solid #F2F2F2",
        boxShadow: disableBorder
          ? ""
          : `
            0px 1px 1px 0px #F2F2F2, 
            0px 4px 24px 0px rgba(166, 166, 166, 0.2)
          `,
        display: "flex",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          flexGrow: 1,
        }}
      >
        <PresenceIndicator status={presenceInformation?.status}>
          <Avatar alt={__("Avatar pracownika")} src={muiAvatar}>
            {initials}
          </Avatar>
        </PresenceIndicator>
        <Box>
          {employeeName && (
            <Typography sx={{ m: 0, fontSize: "14px", lineHeight: "16px" }}>
              <b>{employeeName}</b>{" "}
              <span style={{ color: "#838C96" }}>{`(FK ${fk})`}</span>
            </Typography>
          )}
          {position && (
            <Typography color={blueGrey["500"]} sx={typographySx}>
              {position}
            </Typography>
          )}
          {area && (
            <Typography color={blueGrey["500"]} sx={typographySx}>
              {area}
            </Typography>
          )}
        </Box>
      </Box>
      {onRemove && (
        <IconButton onClick={() => onRemove()}>
          <CloseIcon />
        </IconButton>
      )}
    </Box>
  );
};

export default EmployeeChip;
